// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.part-tag__icon--container {\n  width: 2rem;\n  border-radius: 50%;\n  background-color: rgba(255, 10, 197, 0.5);\n  margin-right: 8px;\n}\n.part-tag__icon {\n  width: 100%;\n  padding: 5px;\n}\n.part-tag__content {\n  padding: 10px;\n  background-color: rgba(255, 10, 197, 0.25);\n}\n", ""]);
// Exports
module.exports = exports;
